import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { toAdmin } from "@/hooks/toAdmin";
import { useStore } from "vuex";
export default defineComponent({
  setup: function setup() {
    var router = useRouter();
    var store = useStore();

    function gosw(_x) {
      return _gosw.apply(this, arguments);
    }

    function _gosw() {
      _gosw = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(index) {
        var aWebSocket;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (index) {
                  aWebSocket = store.state.webSocket.aWebSocket;

                  if (aWebSocket) {
                    aWebSocket.close();
                  }

                  toAdmin("dashboard");
                } else {
                  store.state.column.meunList.some(function (item) {
                    if (item.flag) {
                      router.push({
                        path: item.router
                      });
                    }

                    return item.flag;
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _gosw.apply(this, arguments);
    }

    function toindex() {
      router.push({
        path: "/"
      });
    }

    return {
      gosw: gosw,
      toindex: toindex
    };
  }
});